import PulseLoader from 'atoms/pulseLoader';
import TileHeader from 'atoms/tileHeader';
import React from 'react';
import './fullPageTile.css';
import { FullPageTileProps } from './index.d';

/**
 * This tile can be used as a full page, single tile, that does not require any pulse loader. It will adjust the size based off break-points
 * @param param
 * @deprecated
 */
export const FullPageTile: React.FC<FullPageTileProps> = ({
  children,
  loading,
  wrapperStyle,
  ...rest
}) => {
  return (
    <div className="fullPageTile" style={wrapperStyle}>
      {loading && <PulseLoader />}
      <TileHeader {...rest} />
      {children && children}
    </div>
  );
};

export default FullPageTile;
